var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1760143923262,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12687,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 32C248 32 32 248 32 512s216 480 480 480 480-216 480-480S776 32 512 32z m0 891.408c-226.272 0-411.408-185.136-411.408-411.408 0-226.272 185.136-411.408 411.408-411.408 226.272 0 411.408 185.136 411.408 411.408 0 226.272-185.136 411.408-411.408 411.408z m-34.272-478.512c0 48.288-3.36 355.824 0 355.824 1.68 0 7.968 29.088 34.272 29.088 24.576 0 33.168-24.288 34.176-28.512l0.096-1.152V547.04 444.896a36.384 36.384 0 0 0-11.952-27.072 33.312 33.312 0 0 0-22.32-8.64c-18.864 0-34.272 16.032-34.272 35.712z m0-172.896v34.272c0 18.864 15.408 34.32 34.272 34.32a34.368 34.368 0 0 0 34.272-34.32V272A34.368 34.368 0 0 0 512 237.728 34.368 34.368 0 0 0 477.728 272z",
    fill: "#d81e06",
    "p-id": 12688
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.a4ea0e0f44238e6531b76903167a5a1f.svg";
export { ForwardRef as ReactComponent };